export const colors = {
  primary: '#72bf44',
  primaryDark: '#397615',
  primaryLight: '#cae4b8',
  primaryLighter: '#f1f8ec',
  secundary: '#bada2e',
  defaultColor: '#a6a6a6',
  defaultDarker: '#333333',
  defaultDark: '#666666',
  defaultLight: '#e5e5e5',
  defaultLighter: '#f8f8f8',
  neutral: '#ffffff',
  black: '#000000',
  text: '#333333',
  loyalty: '#AA25D7',
  warning: '#fae800',
  warningLight: '#fffccf',
  danger: '#ed1c24',
  success: '#72bf44',
  green: '#78BE20'
}

export const zIndex = {
  lowest: -10,
  low: -1,
  base: 10,
  medium: 50,
  high: 100,
  highest: 1000
}

const size = {
  mobile: {
    sm: '320px',
    md: '375px',
    lg: '425px'
  },
  tablet: '768px',
  laptop: {
    md: '1024px',
    lg: '1440px'
  },
  desktop: '2560px'
}

export const device = {
  mobile: {
    sm: `(min-width: ${size.mobile.sm})`,
    md: `(min-width: ${size.mobile.md})`,
    lg: `(min-width: ${size.mobile.lg})`
  },
  tablet: `(min-width: ${size.tablet})`,
  laptop: {
    md: `(min-width: ${size.laptop.md})`,
    lg: `(min-width: ${size.laptop.lg})`
  },
  desktop: {
    md: `(min-width: ${size.desktop})`,
    lg: `(min-width: ${size.desktop})`
  }
}
